__turbopack_context__.v({
  "className": "lunchbox_82c51bf9-module__o0-fyG__className",
});
